import React, { Component } from 'react';
import PropTypes from "prop-types";
import "./GenerativeInput.css";
import { apiCall } from '../../../helpers/api';
import { parameters } from '../../../helpers/globalSettings'

export class GenerativeInput extends Component {
    static defaultProps = {
        system: "",
        minimumWords: 10,
        maximumCharacters: 500,
        retryAttempts: 1
    }

    static propTypes = {
        system: PropTypes.string,
        minimumWords: PropTypes.number,
        maximumCharacters: PropTypes.number,
        retryAttempts: PropTypes.number,
        disabled: PropTypes.bool
    }

    constructor(props) {
        super(props);
        this.state ={
            showSuggestedPopup: false,
            generatedText: "Generating...",
        }
    }

    componentDidMount() {
    }

    async generateText(userText, context=[], attempt=0) {
        var response = await apiCall("session/sign",{ "method" : "GET" })
        if (response["success"]) {
            var signedSession = response["success"]["signedSession"]
            var aiResponse = await fetch(`${parameters.ai_backend}/api/1.0/ai/simple`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "room-signed-session" : signedSession
                },
                body: JSON.stringify({ 
                    system : this.props.system,
                    user : userText,
                    context : context
                })
            });
            var aiResult = await aiResponse.json();
            if (aiResult["assistant"].length > this.props.maximumCharacters && attempt < this.props.retryAttempts) {
                context.push({role: "user", content: userText}, {role: "assistant", content: aiResult["assistant"]})
                return this.generateText(`Be more concise and provide a shorter output`, context, attempt+1);
            }
            else {
                this.setState({generatedText: aiResult["assistant"]});
            }
        }
    }

    updateText(child) {
        child.props.onChange({target: {value: this.state.generatedText, id: child.props.id}});
        this.setState({showSuggestedPopup: false, generatedText: "Generating..."});
    }

	render() {
        return (            
            <>
                {React.Children.map(this.props.children, child => {
                    if (child.type === 'textarea') {
                        return (
                            <div className="GenerativeInputContainer">
                                {child}
                                <div className="GenerativeInputControl">
                                <button className={`btn btn-sm btn-outline-primary mt-1 mx-1 GenerativeInputButton ${child.props.value.split(" ").length < this.props.minimumWords || this.props.disabled ? "disabled" : ""}`} onClick={() => {this.setState({showSuggestedPopup: true});this.generateText(child.props.value)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-stars me-1" viewBox="0 0 16 16">
                                        <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
                                    </svg>
                                    Rewrite with AI
                                </button>
                                {this.props.disabled && <div className="GenerativeInputDisabledOverlay">This feature is currently disabled</div>}
                                </div>
                                {this.state.showSuggestedPopup &&
                                    <div className="position-absolute start-0 bottom-0 w-100 h-20 bg-secondary p-2 GenerativeInputSuggestedBoxContainer">
                                        <span className="small ms-1 mb-2">Suggested text:</span>  
                                        <textarea className="form-control GenerativeInputSuggestedTextbox" rows={3} value={this.state.generatedText} disabled/>
                                        <button className={`btn btn-sm btn-primary mt-1 me-1 ${this.state.generatedText === "Generating..." ? "disabled" : ""}`} onClick={() => {this.updateText(child);}}>Replace</button>
                                        <button className="btn btn-sm btn-outline-danger mt-1 ms-1" onClick={() => {this.setState({showSuggestedPopup: false, generatedText: "Generating..."});}}>Discard</button>
                                    </div>
                                }
                            </div>
                        );
                    }
                    return child;
                })}
            </>
        )
	}
}

